(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["derby-header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();

      this.onScrollHandler = this.onScroll.bind(this);
      this.onViewportChange = this.handleViewportChange.bind(this);
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);
    }

    connectedCallback() {
      this.header = this.closest('.section-header') || this.parentElement || this;
      this.stickyType = this.getAttribute('data-sticky-type') || 'none';
      this.mobileQuery = window.matchMedia('(max-width: 989px)');
      this.headerBounds = {};
      this.currentScrollTop = Math.max(
        0,
        window.scrollY || window.pageYOffset || document.documentElement.scrollTop || 0
      );
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.setHeaderHeight();
      this.applyStickyMode();

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });
      window.addEventListener('resize', this.setHeaderHeight, { passive: true });

      if (this.mobileQuery.addEventListener) {
        this.mobileQuery.addEventListener('change', this.onViewportChange);
      } else if (this.mobileQuery.addListener) {
        this.mobileQuery.addListener(this.onViewportChange);
      }

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      window.removeEventListener('resize', this.setHeaderHeight);

      if (this.mobileQuery) {
        if (this.mobileQuery.removeEventListener) {
          this.mobileQuery.removeEventListener('change', this.onViewportChange);
        } else if (this.mobileQuery.removeListener) {
          this.mobileQuery.removeListener(this.onViewportChange);
        }
      }

      if (this.isScrolling) window.clearTimeout(this.isScrolling);
    }

    isMobile() {
      return Boolean(this.mobileQuery && this.mobileQuery.matches);
    }

    isConfiguredAlwaysSticky() {
      return this.stickyType === 'always' || this.stickyType === 'reduce-logo-size';
    }

    setHeaderHeight() {
      if (!this.header) return;
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    handleViewportChange() {
      this.currentScrollTop = Math.max(
        0,
        window.scrollY || window.pageYOffset || document.documentElement.scrollTop || 0
      );
      this.setHeaderHeight();
      this.applyStickyMode();
      this.createObserver();
    }

    applyStickyMode() {
      if (!this.header) return;

      /*
        Phones stay continuously sticky. This avoids the Android Chrome
        address-bar resize being misread as "scroll up / scroll down".
        Desktop continues to use the Header editor setting.
      */
      if (this.isMobile()) {
        this.header.classList.add('shopify-section-header-sticky');
        this.header.classList.remove(
          'shopify-section-header-hidden',
          'animate',
          'scrolled-past-header'
        );
        return;
      }

      if (this.isConfiguredAlwaysSticky()) {
        this.header.classList.add('shopify-section-header-sticky');
        this.header.classList.remove('shopify-section-header-hidden');
      } else if (this.stickyType === 'none') {
        this.header.classList.remove(
          'shopify-section-header-hidden',
          'shopify-section-header-sticky',
          'animate',
          'scrolled-past-header'
        );
      }
    }

    createObserver() {
      if (!this.header) return;
      if (this.observer) this.observer.disconnect();

      this.observer = new IntersectionObserver((entries) => {
        const entry = entries[0];
        if (entry) {
          const rect = entry.boundingClientRect;
          this.headerBounds = {
            top: Math.max(0, rect.top + window.scrollY),
            bottom: Math.max(0, rect.bottom + window.scrollY)
          };
        }
        this.observer.disconnect();
      });

      this.observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = Math.max(
        0,
        window.scrollY || window.pageYOffset || document.documentElement.scrollTop || 0
      );

      /*
        Do not run reveal/hide behavior on phones. The header is intentionally
        stable while the browser's own top bar expands or collapses.
      */
      if (this.isMobile()) {
        if (
          !this.header.classList.contains('shopify-section-header-sticky') ||
          this.header.classList.contains('shopify-section-header-hidden')
        ) {
          this.applyStickyMode();
        }
        this.currentScrollTop = scrollTop;
        return;
      }

      if (this.stickyType === 'none' || this.isConfiguredAlwaysSticky()) {
        this.currentScrollTop = scrollTop;
        return;
      }

      if (this.predictiveSearch && this.predictiveSearch.isOpen) {
        this.currentScrollTop = scrollTop;
        return;
      }

      const boundary = Number.isFinite(this.headerBounds.bottom)
        ? this.headerBounds.bottom
        : this.header.offsetHeight;

      /*
        Ignore microscopic movement. Touch scrolling and browser UI changes can
        produce 1–2px reversals that should not reveal/hide the desktop header.
      */
      const delta = scrollTop - this.currentScrollTop;
      if (Math.abs(delta) < 4) return;

      if (delta > 0 && scrollTop > boundary) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventHide) {
          window.requestAnimationFrame(() => this.hide());
        }
      } else if (delta < 0 && scrollTop > boundary) {
        this.header.classList.add('scrolled-past-header');

        if (!this.preventReveal) {
          window.requestAnimationFrame(() => this.reveal());
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = window.setTimeout(() => {
            this.preventReveal = false;
          }, 80);
          window.requestAnimationFrame(() => this.hide());
        }
      } else if (scrollTop <= Math.max(0, this.headerBounds.top || 0)) {
        this.header.classList.remove('scrolled-past-header');
        window.requestAnimationFrame(() => this.reset());
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.isMobile() || this.isConfiguredAlwaysSticky() || this.stickyType === 'none') return;

      this.header.classList.add(
        'shopify-section-header-hidden',
        'shopify-section-header-sticky'
      );
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.isMobile() || this.isConfiguredAlwaysSticky() || this.stickyType === 'none') return;

      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.isMobile()) {
        this.applyStickyMode();
        return;
      }

      if (this.isConfiguredAlwaysSticky()) {
        this.header.classList.add('shopify-section-header-sticky');
        this.header.classList.remove('shopify-section-header-hidden', 'animate');
        return;
      }

      if (this.stickyType === 'none') {
        this.header.classList.remove(
          'shopify-section-header-hidden',
          'shopify-section-header-sticky',
          'animate',
          'scrolled-past-header'
        );
        return;
      }

      this.header.classList.remove(
        'shopify-section-header-hidden',
        'shopify-section-header-sticky',
        'animate'
      );
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => {
        if (typeof disclosure.close === 'function') disclosure.close();
      });
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal && typeof this.searchModal.close === 'function') {
        this.searchModal.close(false);
      }
    }
  }

  if (!customElements.get('sticky-header')) {
    customElements.define('sticky-header', StickyHeader);
  }

  } catch(e) { console.error(e); }
})();
})();
